// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6GVbV","logo":"Header_logo__Pbntt"};